<template>
	<div class="loginForm form">
		<h4 class="mb-3">Control de Acceso</h4>
		<span v-if="emailChecked == -1" class="mb-3">Para comenzar ingrese su correo electronico</span>
		<span v-if="emailChecked == 1" class="mb-3">Hola {{this.objectClient.name}} {{this.objectClient.surname}}, ahora ingrese su contraseña</span>
		<input class="mb-3" type="email" id="form3Example3" v-show="emailChecked == -1" v-model="email" :readonly="(emailChecked != -1)" placeholder="Correo Electronico"/>
		<input class="mb-3" type="password" id="passwordInput" v-show="emailChecked == 1" placeholder="Ingrese su contraseña"	v-model="password" :readonly="(emailChecked == -1)">			
		<router-link :to="'/changepassword/' + objectClient.token" v-if="objectClient.token" class="mb-3">Olvidé mi contraseña</router-link>
		<button type="button" @click="next" ref="btnCheckMail" :disabled="disabledNext || checkingMail">
			<span v-if="!checkingMail">Siguiente</span>
			<span v-else>Verificando...</span>
		</button>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAWN from '@/mixins/axiosAWN.js'
	import client from '@/mixins/client.js'

	export default {
		name: 'LoginForm',
		mixins: [mixin, client, axiosAWN],
		props: ['emailRegister'],
		data() {
			return {
				emailChecked: -1,
				checkingMail: false,
				email: this.emailRegister,
				token: '',
				password: '',
				panel: false
			}
		},
		computed: {
			disabledNext() {
				if(this.emailChecked == -1) {
					return !this.validateEmail(this.email)
				}
				return false
			}
		},
		methods: {
			initComponentLocal() {
			},
			checkMail() {
				this.token = ''
				this.checkingMail = true
				if(this.validateEmail(this.email)) {
					let url = this.getApiBackend + 'register/checkMail2'
					let data = {email: this.email}
					this.axiosAWNasyncBlock('Chequeando a ' + this.email, 'POST', url, 'checkMailResult', data)
				}
			},
			checkMailResult(response) {
				this.checkingMail = false
				if(response.data.success == true) {
					if(response.data.data.password) {
						this.emailChecked = 1
						this.objectClient.name = response.data.data.name
						this.objectClient.surname = response.data.data.surname
						this.objectClient.email = response.data.data.email
						this.objectClient.phone = response.data.data.phone
						this.objectClient.token = response.data.data.token
					} else {
						this.$router.push('/changepassword/'+ response.data.data.token)
					}
				} else if(response.data.success == false) {
					let onOk = () => { this.$emit('actionRegister', this.email) };
					this.panel = !this.panel
					this.$awn.confirm('El email ' + this.email + ' no está en nuestros registros. <br> ¿Quiere registrase?', onOk)
				} else {
					console.log(response)
					alert('Algo no anda bien, comunicate con el Soporte')
				}
			},
			checkMailResultError(error) {
				this.checkingMail = false
			},
			checkPassword() {
				this.checkingMail = true
				let url = this.getApiBackend + 'client/checkPassword'
				let data = {email: this.email, password: this.password, token: this.objectClient.token }
				this.axiosAWNasyncBlock('Verificando la contraseña', 'POST', url, 'checkPasswordResult', data)
			},
			checkPasswordResult(response) {
				if(response.data.success == true) {
					localStorage.setItem('token', response.data.data.token)
					this.$router.push('/loading')
				} else {
					this.checkingMail = false
					this.$awn.alert('No es la contraseña registrada')
				}
			},
			checkPasswordResultError(error){
				this.checkingMail = false
				console.log(error)
			},
			next() {
				if(this.emailChecked == -1) {
					this.checkMail()
				} else {
					this.checkPassword()
				}
			}
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>

<style scoped lang="scss">
a {
	color: #333;
	font-size: 14px;
	text-decoration: none;
	margin: 15px 0;
}

button {
	border-radius: 20px;
	border: 1px solid #FF4B2B;
	background-color: #FF4B2B;
	color: #FFFFFF;
	font-size: 12px;
	font-weight: bold;
	padding: 12px 45px;
	letter-spacing: 1px;
	text-transform: uppercase;
	transition: transform 80ms ease-in;
}

button:active {
	transform: scale(0.95);
}

button:focus {
	outline: none;
}

button:disabled, button[disabled] {
	opacity: 0.5;
}

.form {
	justify-content: center;
}

input {
	background-color: #eee;
	border: none;
	padding: 12px 15px;
	margin: 8px 0;
	width: 100%;
}
</style>
